<template>
  <div class="noticeAddEdit">
    <el-dialog v-dialogDrag :title="dialogTitle" :visible.sync="isShow" :close-on-click-modal="false"
      :close-on-press-escape="false" width="924px" class="addDialog">
      <el-form ref="announForm" :model="announForm" :inline="true" class="formOfDialog" :rules="rules"
        label-width="90px" size="small">
        <div class="formElement">
          <el-form-item label="标题:" prop="noticeTitle">
            <el-input ref="noticeTitle" v-model.trim="announForm.noticeTitle" placeholder="请输入" maxlength="25" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="摘要:" prop="noticeAbstract">
            <el-input v-model.trim="announForm.noticeAbstract" type="textarea" placeholder="请输入" maxlength="50"
              show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="内容:" prop="content">
            <el-input v-model.trim="announForm.content" style="display:none"></el-input>
            <div style="width:720px;height:500px">
              <quill-editor ref="myTextEditor" v-model.trim="announForm.content" :disabled="disabled"
                :options="editorOption"></quill-editor>
            </div>
          </el-form-item>
          <el-form-item label="附件:">
            <el-button icon="el-icon-plus" type="primary" plain size="small" @click="uploadFile">上传文件</el-button>
            <el-table v-if="fileDatas.length > 0" :data="fileDatas" :show-header="false" max-height="200px">
              <el-table-column label="名称" prop="fileName"></el-table-column>
              <el-table-column label="操作" fixed="right" width="120px">
                <template slot-scope="scope">
                  <span class="midd-table">
                    <i class="el-icon-delete" title="删除" @click="deleteRow(scope.$index, fileDatas)" />
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="置顶:">
            <el-radio-group v-model="announForm.isTop">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否公开:">
            <el-radio-group v-model="announForm.isOpen">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="announForm.isOpen===0" label="可见人:" prop="userNames">
            <el-input v-model="announForm.userNames" readonly>
              <template slot="append">
                <el-button size="small" @click="visiblePersonOpen">请选择</el-button>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="addSurea(0)">存草稿</el-button>
        <el-button size="small" @click="previewa()">预览</el-button>
        <el-button size="small" type="primary" @click="addSurea(1)">发布</el-button>
        <el-button size="small" @click="isShow=false">取 消</el-button>
      </div>
    </el-dialog>
    <selectMembers :is-show.sync="membersChooseShow" :select-person-list="selectPersonTemp"
      :type="name==='prj'?'项目公告':'系统公告'" @change="toSelectMembers">
    </selectMembers>
  </div>
</template>

<script>
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { mapState } from "vuex";
import selectMembers from "@/CommonDP/components/selectMembers";
export default {
  components: {
    quillEditor,
    selectMembers
  },
  props: {
    dialogTitle: {
      type: String,
      required: true,
      default: "新增"
    },
    announdialogVisible: {
      type: Boolean,
      required: true,
      default: false
    },
    close: {
      type: Function,
      required: true,
      default: () => {}
    },
    announForm: {
      type: Object,
      required: true,
      default: () => {}
    },
    addSure: {
      type: Function,
      required: true,
      default: () => {}
    },
    preview: {
      type: Function,
      required: true,
      default: () => {}
    },
    fileData: {
      type: Array,
      required: true,
      default: () => []
    },
    name: {
      type: String,
      required: true,
      default: () => ""
    },
    selectPersonList: {
      type: Array,
      required: true,
      default: () => []
    },
    uploadFilea: {
      type: Function,
      required: true,
      default: () => {}
    }
  },
  data() {
    const toolbarOptions = [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{ header: 1 }, { header: 2 }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ header: [1, 2, 3, 4, 5, 6] }],
      [{ color: [] }, { background: [] }],
      [{ font: [] }],
      [{ align: [] }],
      ["link", "image"] // 去除video即可
    ];
    const validateContent = (rule, value, callback) => {
      var str = /<\/?(?!img)[a-z]+?[^>]*>/gi;
      var z = value.replace(str, "");
      var test = z;
      test = test.replace(/ /gi, "");
      if (value === "") {
        callback(new Error("内容不能为空"));
      } else if (test.trim() == null || test.trim() == "" || test.trim() == undefined) {
        callback(new Error("内容不能为空"));
      } else {
        callback();
      }
    };
    const userNamesV = (rule, value, callback) => {
      if (this.announForm.userNames === "") {
        callback(new Error("可见人不能为空"));
      } else {
        callback();
      }
    };
    return {
      editorOption: {
        placeholder: "请输入",
        theme: "snow",
        modules: {
          toolbar: toolbarOptions
        }
      },
      rules: {
        noticeTitle: [{ required: true, message: "标题不能为空", trigger: "change" }],
        noticeAbstract: [{ required: true, message: "摘要不能为空", trigger: "change" }],
        content: [{ required: true, trigger: "change", validator: validateContent }],
        userNames: [{ required: true, trigger: "change", validator: userNamesV }]
      },
      disabled: false,
      membersChooseShow: false,
      selectPersonTemp: this.selectPersonList
    };
  },
  computed: {
    ...mapState({
      uploadFilesDataPrj: (state) => state.prjNotice.uploadFilesData,
      uploadFilesDataSys: (state) => state.sysNotice.uploadFilesData
    }),
    isShow: {
      set() {
        this.close();
      },
      get() {
        if (this.announdialogVisible) {
          this.$nextTick(() => {
            this.$refs.noticeTitle.focus();
            this.$refs.announForm.resetFields();
          });
        }
        return this.announdialogVisible;
      }
    },
    fileDatas: {
      set() {},
      get() {
        return this.fileData;
      }
    }
  },
  watch: {
    uploadFilesDataPrj(newValue, oldValue) {
      if (newValue.fileId) {
        this.fileDatas.push(newValue);
      } else {
        this.fileDatas = [];
      }
    },
    uploadFilesDataSys(newValue, oldValue) {
      if (newValue.fileId) {
        this.fileDatas.push(newValue);
      } else {
        this.fileDatas = [];
      }
    },
    fileDatas(newValue, oldValue) {
      if (this.name === "prj") {
        this.$store.dispatch("setuploadFilesArr", newValue);
      } else {
        this.$store.dispatch("setSysUploadFilesArr", newValue);
      }
    },
    selectPersonList() {
      this.selectPersonTemp = this.selectPersonList;
    }
  },
  created() {},
  methods: {
    toSelectMembers(data) {
      this.selectPersonTemp = data;
      this.announForm.userIds = data.map((item) => {
        return item.userId;
      });
      this.announForm.userNames = data.map((ele) => ele.name).join(",");
    },
    visiblePersonOpen() {
      this.membersChooseShow = true;
    },
    uploadFile() {
      this.uploadFilea();
    },
    deleteRow(index) {
      const res = new Map();
      this.fileDatas = this.fileDatas.filter((a) => !res.has(a.fileName) && res.set(a.fileName, 1));
      this.fileDatas.splice(index, 1);
      if (this.name === "prj") {
        this.$store.dispatch("setuploadFilesArr", this.fileDatas);
      } else {
        this.$store.dispatch("setSysUploadFilesArr", this.fileDatas);
      }
    },
    previewa() {
      this.preview(this.announForm);
    },
    addSurea(val) {
      this.$refs.announForm.validate((valid) => {
        if (valid) {
          this.addSure(this.announForm, this.fileDatas, val);
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addDialog {
  /deep/ .el-dialog {
    p {
      font-size: 14px !important;
    }
    min-width: 420px;
    .el-dialog__body {
      padding: 18px !important;
      .formOfDialog {
        width: 905px;
        margin: auto;
        .formElement {
          .quill-editor {
            height: 80%;
          }
          .el-form-item__content {
            width: 720px;
          }
          .el-textarea__inner {
            height: 75px;
          }
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
}
</style>
